import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintEntityId} from "../utils/uid.utils";
import {AddImagePackCommand} from "./addImagePack.command";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";

export class AddBuildingCommand extends CommandBase {
    private name: string;
    // Id minted for the created building; read after executeCommand to focus it.
    newId = '';
    constructor(name: string = 'New Building') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        const id = mintEntityId('building', this.name, data.buildings.map(b => b.id));
        this.newId = id;
        data.buildings.push({
            id: id,
            active: true,
            price: 5,
            score: 1,
            startLevel: 1,
            maxLevel: 0,
            maxPerCity: 0,
            maxPerPlayer: 0,
            properties: {
                visionRange: 1,
                territoryRange: 0,
                startingSlots: 0,
                // health 0 = an ordinary, non-combat building. Raising it is what
                // turns a new building into a destructible combat structure.
                health: 0,
                attack: 0,
                defense: 0,
                range: 0,
                regeneration: 0
            },
            attributes: [],
            produceableUnits: [],
            constructionTurns: 0,
            resourceVariants: {},
            // Index 0 is a dead slot — buildings start at Level 1 in the
            // runtime, so `rewards[0]` is never used. We seed it as an empty
            // array so the editor's Rewards tab can safely skip rendering it
            // without leaving the building looking like it has no levels.
            rewards: [[]],
            passiveRewards: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);   // seeds [[id]] — the Level-1 image
        // startLevel is 1, so pack index 0 is a hidden dead slot. Reserve it with
        // a BLANK placeholder (not the id) so the building's image isn't
        // duplicated into the dead slot — that duplication is what made buildings
        // show two identical "City"-style entries. Result: [[''], [id]].
        data.imagePacks[id].unshift(['']);
        return true;
    }
}
